import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { vehicles } from '../../../../../../redux/vehicles/action';
import VehicleComponent from '../components/vehicle.component';
import { agents } from '../../../../../../redux/agents/action';
import { selectTransportersListItems } from '../../../../../../redux/transporters/selector';
import { selectVehiclesQueryItems } from '../../../../../../redux/vehicles/selector';
import { selectAgentsListItems } from '../../../../../../redux/agents/selector';
import PageLoader from '../../../../../../components/PageLoader';
import { transporters } from '../../../../../../redux/transporters/action';


const TransportAgentVehicle= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const parmas: any = useParams()
  const vehicleQuery = useSelector(selectVehiclesQueryItems)
  const transportAgentListItems = useSelector(selectAgentsListItems)
  const transporterListItems = useSelector(selectTransportersListItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedVehicle,
    setSelectedVehicle
  ] = useState<any>([])
 

  const fetchVehicleById= ()=>{
    dispatch(vehicles.query({url:`https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/vehicle-registations/query`,entity:'vehicles',jsonData:{
          
    Records: [
      {
        Id: parmas?.id
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
}).then(() => {
  setIsLoading(false)
})
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedVehicle({ ...selectedVehicle, [field]: event });
  }

  useEffect(
    () => {
      dispatch(agents.list({url:`https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/transport-agents/list`,entity:'agents',jsonData:{
            
    }})).then(() => {
    dispatch(transporters.list({url:`https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/transporters/list`,entity:'transporters',jsonData:{
            
    }}))
  }).then(() => {
      if (parmas?.id > 0) {
        fetchVehicleById()
        setIsLoading(false)
      } else {
          setIsLoading(false)
      
      }
    })
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedVehicle(vehicleQuery?.result?.items)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
     dispatch(vehicles.update({url:`https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/vehicle-registations`,entity:'vehicles',jsonData:{
          
    Records: [
        selectedVehicle
    ]
 
}})).then(() => {
  dispatch(vehicles.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/vehicle-registations/list`,
      entity: 'vehicles',
      jsonData: {}
  }));
});

    }else{
      dispatch(vehicles.create({url:`https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/vehicle-registations`,entity:'vehicles',jsonData:{
          
      Records: [
        selectedVehicle
      ]
    
  }})).then(() => {
    dispatch(vehicles.list({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/vehicle-registations/list`,
        entity: 'vehicles',
        jsonData: {}
    }));
});
    }
   
    back()
    
  }

const back=()=>{
  navigate('/transport-agent/logistics/transport/vehicle-registations')
} 

    return (
    <>
     {isLoading ? <PageLoader /> :
          <VehicleComponent 
          handleInnerFormChange={handleInnerFormChange}
          selectedVehicle={selectedVehicle}
          transportAgents={transportAgentListItems?.result?.items}
          transporters={transporterListItems?.result?.items}
          back={back}
          handleFormSubmit={handleFormSubmit}
          /> 
     } 
          </>
    )
    
    }
   
    export default TransportAgentVehicle;